import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import {
  ActiveInactiveSize,
  createSize,
  deleteSize,
  getAllActiveSize,
  getAllSize,
  getSizeByID,
  updateSize,
} from "./services/size.services";

export interface ISizeState {
  loading: boolean;
  formloading: boolean;
  error: string;
  SizeID: number | null;
  SizeList: ISize[];
  SizeDetail: ISizeDetails;
}

export interface ISizeDetails {
  ID?: number | null;
  Size: string;
  IsActive: number | boolean;
}
export interface ISize {
  Size: string;
  IsActive: number | boolean;
}

const initialState: ISizeState = {
  loading: false,
  formloading: false,
  error: "",
  SizeID: null,
  SizeList: [],
  SizeDetail: {
    Size: "",
    IsActive: 1,
  },
};

const sizeSlice = createSlice({
  name: "size",
  initialState,
  reducers: {
    clearSizeDetails: (state) => {
      state.SizeDetail = initialState.SizeDetail;
    },
    setSizeID: (state, action) => {
      state.SizeID = action.payload;
    },
    clearSizeID: (state) => {
      state.SizeID = initialState.SizeID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllSize.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllSize.fulfilled,
      (state, action: PayloadAction<ISize[]>) => {
        state.loading = false;
        state.SizeList = action.payload || [];
      }
    );
    builder.addCase(getAllSize.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.SizeList = [];
    });
    builder.addCase(createSize.pending, (state) => {
      state.formloading = true;
      state.error = "";
    });
    builder.addCase(createSize.fulfilled, (state) => {
      state.formloading = false;
    });
    builder.addCase(createSize.rejected, (state, action) => {
      state.formloading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateSize.pending, (state) => {
      state.formloading = true;
      state.error = "";
    });
    builder.addCase(updateSize.fulfilled, (state) => {
      state.formloading = false;
    });
    builder.addCase(updateSize.rejected, (state, action) => {
      state.formloading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteSize.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteSize.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteSize.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getSizeByID.pending, (state) => {
      state.formloading = true;
      state.error = "";
    });
    builder.addCase(getSizeByID.fulfilled, (state, action: any) => {
      state.formloading = false;
      state.SizeDetail = action.payload;
    });
    builder.addCase(getSizeByID.rejected, (state, action) => {
      state.formloading = false;
      state.SizeDetail = initialState.SizeDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveSize.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveSize.fulfilled,
      (state, action: PayloadAction<ISize[]>) => {
        state.loading = false;
        state.SizeList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveSize.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.SizeList = [];
    });
    builder.addCase(ActiveInactiveSize.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveSize.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveSize.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearSizeDetails, clearSizeID, setSizeID } = sizeSlice.actions;
export default sizeSlice.reducer;
